
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationDuplicateHeadline: {
    id: "ConfigurationDuplicate.headline",
    defaultMessage: "Want to duplicate your configuration?",
  },
  configurationDuplicateButton: {
    id: "ConfigurationDuplicate.button",
    defaultMessage: "Duplicate",
  }, 
});

export default MESSAGES;